interface BrgColorKeyProps {
  colorMap: Map<number, { name: string; color: string }>;
}

export function BrgColorKey({ colorMap }: BrgColorKeyProps) {
  const colors = Array.from(colorMap.values()).sort((a, b) => a.name.localeCompare(b.name));

  return (
    <div
      style={{
        backgroundColor: '#f8f9fa',
        border: '1px solid #e0e0e0',
        borderRadius: '4px',
        padding: '16px 20px',
        marginTop: '24px',
      }}
    >
      <h3 style={{ margin: '0 0 16px 0', fontSize: '0.95rem', fontWeight: 600, color: '#1a1a1a' }}>
        BRG Color Legend
      </h3>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '12px 20px',
        }}
      >
        {colors.map((item) => (
          <div key={item.name} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div
              style={{
                width: '14px',
                height: '14px',
                borderRadius: '3px',
                backgroundColor: item.color,
                border: '1px solid rgba(0, 0, 0, 0.1)',
                flexShrink: 0,
              }}
            />
            <span style={{ fontSize: '0.85rem', color: '#444', fontWeight: 500 }}>{item.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
